// extracted by mini-css-extract-plugin
export default {"wrapper":"Login_wrapper__1LiKe","form":"Login_form__uKqd1","title":"Login_title__ebgc6","amprimary":"Login_amprimary__Z+duy"};